export const CUSTOM_FIELD_LEVELS = ['global', 'item'] as const;

export type CustomFieldLevel = (typeof CUSTOM_FIELD_LEVELS)[number];

export const CUSTOM_FIELD_TYPES = [
  'string',
  'enumeration',
  'double',
  'value_measure',
  'legal_organization',
  'bool',
  'datetime',
  // 'dict', // Ignore - not supported by the backend yet
] as const;

export type CustomFieldType = (typeof CUSTOM_FIELD_TYPES)[number];

export const CUSTOM_FIELD_VISIBILITY = ['always', 'when_set', 'never'] as const;

export type CustomFieldVisibility = (typeof CUSTOM_FIELD_VISIBILITY)[number];
